module.exports = __webpack_public_path__ + "img/BG_blue1.52e8e6ef.jpg";